import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardPage } from './dashboard.page';
import { OrgGuard } from '@core/auth/guards/authorg.guard';

const routes: Routes = [
  {
    path: 'estadisticas',
    component: DashboardPage
  },
  {
    path: 'informes',
    loadChildren: () =>
      import('./informes/informes.module').then((m) => m.InformesModule),
  },
  {
    path: 'embeddable',
    canActivate: [OrgGuard],
    loadChildren: () =>
      import('./embeddable/embeddable.module').then((m) => m.EmbeddableModule),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
  },
  {
    path: '**',
    redirectTo: 'estadisticas'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardPageRoutingModule { }
